module.exports = __webpack_public_path__ + "static/Cherenlogo-546e8b7ba4dee32bacfcc7a241e3712e.png";